import apiClient from './api';

const voiceService = {
  uploadAudio: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/voice/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  processCommand: async (text) => apiClient.post('/voice/process', { text }),
  getCommands: async () => apiClient.get('/voice/commands'),
  getCommandExamples: async () => apiClient.get('/voice/examples'),
};

export default voiceService;
